<div class="flex flex-col" *ngIf="session()">
  <img class="w-full h-30 object-cover rounded-lg" loading="lazy" decoding="async"
       src="https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/places/{{session()?.placeId}}.webp"
       alt="{{session().cityName}}">

  <p class="font-theme-source -mt-10 pr-3 text-right z-9998">
    <span class="bg-white p-1 font-bold rounded-lg" *ngIf="subscriptionContextV2Service.defaultOffer()">{{subscriptionContextV2Service.defaultOffer().price | showPrice}}</span>
  </p>

  <div class="flex flex-row border-b-1 pb-1 mt-7">
    <p class="font-theme-source w-full text-sm 2xs:text-base md:text-lg"><span class="font-bold">{{session().shortDescription}}<br></span><span class="text-sm">{{session().description}}</span></p>
    <p class="font-theme-source w-full text-right text-sm 2xs:text-base md:text-lg font-bold">{{session().date | showEventDate}}<br>{{session().date | showFreeDate: 'HH:mm'}}</p>
  </div>

  <div class="flex flex-wrap mt-3" >
    <p class="pl-2 pr-2 text-sm text-white rounded-full bg-theme-red-110 mb-1">{{session().capacity}} pers.</p>
    <p *ngIf="session().topic!='lgbt_w'" class="pl-2 pr-2 text-sm text-white rounded-full bg-theme-purple-110 ml-1 mb-1">
      Parité H / F
    </p>
    <p class="pl-2 pr-2 text-sm text-white rounded-full bg-theme-green-110 ml-1 mb-1">50% offert pour les amis</p>
  </div>
  <div class="flex flex-wrap mt-3 font-theme-source" >
    <p class="pr-2 text-sm text-theme-black mr-1 mb-1">Ages:</p>
    <p class="pl-2 pr-2 text-sm text-white rounded-full bg-theme-black mr-1 mb-1" *ngFor="let ageThread of ageThreads(session())">{{ageThread}}</p>
  </div>
  <div class="flex flex-col mt-3 font-theme-source">
    <p class="text-xs text-theme-black"><strong>Tu n'es pas dans ces tranches ?</strong> Inscris-toi : tu seras mis en liste d'attente gratuitement pour analyse en fonction des autres inscrits.</p>
  </div>
  <div class="w-full flex flex-col mt-3">
    <p class="font-theme-source text-sm">
      <span *ngIf="subscriptionContextV2Service.defaultOffer()">
        <span *ngFor="let item of subscriptionContextV2Service.defaultOffer().lpItems">
          <i class="fa-solid fa-check text-theme-green-110 mr-2 mt-2"></i> <span [innerHTML]="item"></span><br/>
        </span>
      </span>
    </p>
  </div>
</div>
